<template>
  <!-- eslint-disable vuejs-accessibility/click-events-have-key-events, vuejs-accessibility/no-static-element-interactions -- tracking-only: measure whether users try to click a non-interactive chip -->
  <div
    v-if="shouldDisplayRating"
    :aria-label="ratingAriaLabel"
    class="bg-action-default-mid caption flex h-28 shrink-0 items-center rounded-full px-6"
    data-test="sticky-bar-rating-chip"
    role="img"
    @click="onRatingClick"
  >
    <IconStarFilled aria-hidden="true" size="16" />
    <span class="px-4">{{ displayedRating }}/5</span>
  </div>
  <!-- eslint-enable vuejs-accessibility/click-events-have-key-events, vuejs-accessibility/no-static-element-interactions -->
</template>

<script lang="ts" setup>
import { IconStarFilled } from '@ds/icons/IconStarFilled'

import { useStickyBarRating } from './composables/useStickyBarRating'

const { shouldDisplayRating, displayedRating, ratingAriaLabel, onRatingClick } =
  useStickyBarRating()
</script>
